module.exports = __webpack_public_path__ + "static/media/mental-threats-large@3x.8ae0dc71.png";